import {
  PageProps,
  getStoryBySlug,
  useStoryblokState,
} from '@cinch-nx/data-storyblok'
import {
  PartnershipsFeature,
  PartnershipsStoryContent,
} from '@cinch-nx/landing-feature-partnerships'
import Head from '@cinch-nx/landing-ui-shared/lib/head/head'
import type { GetStaticProps } from 'next'

const Partnerships: React.FC<PageProps<PartnershipsStoryContent>> = ({
  story,
  preview,
  generatedAt,
}) => {
  const { content } = useStoryblokState({ story, enableBridge: preview })

  const SEO = content?.SEO?.[0]

  return (
    <>
      <Head
        {...SEO}
        generatedAt={generatedAt}
        fallbackTitle="Partnerships - cinch"
        fallbackDescription="We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with free home delivery or from an approved dealer."
      />

      {content && <PartnershipsFeature content={content} />}
    </>
  )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  const story = await getStoryBySlug<PartnershipsStoryContent>('partnerships', {
    version: preview ? 'draft' : 'published',
  })

  if (!story) {
    throw new Error('Unable to fetch `partnerships` story from storyblok')
  }

  const HeroProps = story.content?.Hero?.[0]

  return {
    props: {
      story,
      preview,
      generatedAt: Date.now().toString(),
      layoutProps: {
        heroProps: HeroProps,
        showBorderRadius: true,
      },
    },
    revalidate: 300, // In seconds
  }
}

export default Partnerships
